import Head from 'next/head';

import {HeadSEO} from '@udemy/head-seo';
import {useI18n} from '@udemy/i18n';

import {PageProps} from 'src/types/page-props';

import {useSetupNavigation} from '../../hooks/use-setup-navigation';
import {useCanonicalUrl} from '../../hooks/useCanonicalUrl';
import {META_DEFAULT_BASE_URL} from '../../lib/constants';
import {RolePlayLandingPage} from './role-play-landing-page.react-component';

export type RolePlayLandingPageFeatureProps = PageProps;

export const RolePlayLandingPageFeature: React.FC<RolePlayLandingPageFeatureProps> = (props) => {
    const {gettext} = useI18n();
    const {url: canonicalUrl} = useCanonicalUrl([], META_DEFAULT_BASE_URL);
    useSetupNavigation();

    const metaProps = {
        title: gettext('Turn learning into real-world practice with Role Play | Udemy'),
        description: gettext(
            'Knowing and doing are not the same. Role Play is your chance to put new skills to the test before it counts. Step into realistic scenarios right after you learn, practice with an AI-powered avatar, get feedback, and go again until it clicks.',
        ),
    };

    return (
        <>
            <HeadSEO
                title={metaProps.title}
                ogTitle={metaProps.title}
                description={metaProps.description}
                ogDescription={metaProps.description}
                ogLocale={process.env.I18N_PATH_TO_BUNDLE_MAP[props.locale]}
                canonicalUrl={canonicalUrl}
                assetPath={process.env.ASSET_PREFIX}
                headWrapper={Head}
            />
            <RolePlayLandingPage {...props} />
        </>
    );
};
